import { useAuth } from '../context/AuthContext'
import { PrintersPanel } from '../components/settings/PrintersPanel'
import { DeviceRows } from '../components/settings/DeviceRows'
import { PrinterlessNote, UsePrinterSwitch } from '../components/settings/UsePrinterSwitch'
import './SettingsPage.css'

/**
 * Kasiyerin Yazıcılar sayfası (kullanıcı, 20 Eki 2026).
 *
 * Ayarlar yalnız patrona açık, ama kasa bilgisayarını çoğu zaman kasiyer
 * kuruyor: otomatik yazdırma, ağ yazıcılarına gönderme, kasa numarası ve
 * kurulum dosyası bu cihazın ayarları. Yazıcı listesi kurumun, her cihazı
 * etkiliyor; onu yalnız patron değiştiriyor, burada salt okunur.
 */
export function PrintersPage() {
  const { can, usePrinter } = useAuth()
  // Patron ya da ayar izni olan müdür değiştirir (3 Kas 2026); kasiyer yalnız görür.
  const readOnly = !can('settings')

  return (
    <div className="settings-page settings-page--wide">
      <div className="set-page-head">
        <h1>Yazıcılar</h1>
      </div>
      <div className="set-page-body">
        {/* Anahtar kurumun; kasiyer görür, patron değiştirir. */}
        <UsePrinterSwitch readOnly={readOnly} />
        {usePrinter ? <PrintersPanel deviceRows={<DeviceRows />} readOnly={readOnly} /> : <PrinterlessNote />}
      </div>
    </div>
  )
}
